import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    padding: '16px 16px 20px',
    '& + $root': {
      borderTop: `1px solid ${theme.palette.primary.A100}`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
  },
});

const OrderInformationSection = ({
  children, className, classes,
}) => (
  <div
    className={classNames(className, classes.root)}
  >
    {children}
  </div>
);

OrderInformationSection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationSection.defaultProps = {
  className: '',
};

export default withStyles(styles)(OrderInformationSection);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationSection.js